import React from 'react'
import { StyledTxtArea } from './styles'

const FormTxtArea = React.forwardRef(({ placeholder, onChangeVal, ...rest }, ref) => (
  <StyledTxtArea
    placeholder={placeholder}
    ref={ref}
    onChange={e => onChangeVal(e)}
    {...rest}
  />
))

export default FormTxtArea